import { Injectable } from "@angular/core";
import { OnboardingApi } from "../api/onboarding.api";
import { PvaasDataApi } from "../api/pvass-data.api";

@Injectable()
export class PvassDataService {


  constructor(private pvaasDataApi: PvaasDataApi) {}


  //getTemplate = () => this.onboardingApi.getTemplate();

  uploadPvaasData = (fileToUpload: File, type: number,schoolYear: string) =>
    this.pvaasDataApi.uploadPvaasData({fileToUpload, type, schoolYear});

  getUploadEvents = (increment:number = 10, index:number = 0) =>
    this.pvaasDataApi.getUploadEvents(increment, index);

  getPvaasData= (schoolYear:string) =>
    this.pvaasDataApi.getPvaasData(schoolYear);

  deletePvaasData =(ViewSchoolYear: string) =>
    this.pvaasDataApi.deletePvaasData(ViewSchoolYear);


}
